import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Search from "@insite/mobius/Icons/Search";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

searchBoxStyles.search = {
    iconProps: { src: Search },
    cssOverrides: {
        formField: css`
            > div[class^="FormInputWrapper"] {
                input {
                    padding-right: 30px;
                }
            }
        `,
    },
}
